import { makeObservable, observable, reaction } from "mobx"
import { getTemplate } from 'ynf-core-engine/actions/print'

export default class PrintStore {
  rootStore: any
  formStoreKey: string = 'formStore'
  cardStoreKey: string = 'cardStore'
  formStore: any
  cardStore: any
  tempData: any = []
  dataSourceAlias: string = 'mainEntity'

  constructor(props: any) {
    this.rootStore = props.rootStore;
    this.formStoreKey = props.formStoreKey || 'formStore'
    this.cardStoreKey = props.cardStoreKey || 'cardStore'
    this.formStore = this.rootStore.get(this.formStoreKey) || {}
    this.cardStore = this.rootStore.get(this.cardStoreKey) || {}
    this.dataSourceAlias = props.dataSourceAlias || 'mainEntity'

    makeObservable(this, {
      tempData: observable
    })

    reaction(() => this.cardStore.paramsLoaded && (this.formStore.masterOrgValue + this.formStore.transTypeValue), () => {
      this.getTemplateData()
    })
    
    /**
     * 编辑页到详情页没有调reaction
     * 原因是详情和编辑页用的同一个formStore 所以没有触发reaction变化
     * 解决方式：当详情页加载完数据后，如果没有调过getTemplateData，就调一次
     */
    if (this.cardStore.paramsLoaded && this.cardStore.isBrowse && !this.tempData.length) {
      this.getTemplateData()
    }
  }

  async getTemplateData() {
    const tempData = await getTemplate(this.rootStore, {
      dataSourceAlias: this.dataSourceAlias,
      formStoreKey: this.formStoreKey
    })
    this.tempData = tempData.data ||  []
  }
}